import Requisicao from "./RequisicaoService";

class NotificacaoAparelhoService {       
    static async gravar(dados) {                                    
        return Requisicao.post('notificacao/aparelho', JSON.stringify(dados), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }     

    static async delete(id) {
        return Requisicao.delete('notificacao/aparelho/' + id);
    }
}

export default NotificacaoAparelhoService;